import React, { useState, useCallback } from 'react'
import { useMediaQuery } from 'react-responsive'

import styles from './ReviewThumbs.module.scss'
import ModalPortal from '../../../ModalPortal'
import ModalReviewDetail from '../../modal/ModalReviewDetail'

export default function ReviewThumbs({ item, onClickToDetail, comment }) {
  const deviceCheck = useMediaQuery({ maxWidth: 1024 }) ? true : false
  const [modalopen, setModalopen] = useState(false)

  const [images, setImages] = useState(null)

  const handleOpenModal = useCallback(
    (images) => {
      document.body.classList.add('modal-open')
      setImages(images)
      setModalopen(!modalopen)
    },
    [modalopen]
  )

  const handleCloseModal = useCallback(() => {
    document.body.classList.remove('modal-open')
    setModalopen(false)
  }, [])

  // 썸네일 아닌 바깥영역 클릭 시 상세 페이지 이동
  const onClickItem = (e) => {
    e.preventDefault()
    onClickToDetail()
  }

  // 썸네일 클릭 시 모달 열기
  const onClickThumb = (e) => {
    e.stopPropagation()
    handleOpenModal(item.attachments)
  }

  return (
    <div className={styles.reviewThumbs}>
      {item.attachments?.length > 0 ? (
        <div className={styles.list} type="button" onClick={onClickItem}>
          {item.attachments.map((files, idx) => {
            return (
              <span
                key={idx}
                className={styles.itemThumbSpan}
                style={{
                  background: `url(${
                    files.thumbnailPath ? files.thumbnailPath : files.url || files.imageUrl
                  }) no-repeat center / cover`
                }}
                onClick={onClickThumb}
              ></span>
            )
          })}
        </div>
      ) : (
        <button
          className={styles.list}
          type="button"
          onClick={() => {
            handleOpenModal(item)
          }}
          style={{
            '--padding': !comment ? '1.5rem 0 0 0' : '2.3rem 3.5rem 3.5rem',
            '--padding-mobile': !comment ? '3rem 0 0 0' : '4rem'
          }}
        >
          <span
            className={styles.itemThumbSpan}
            style={{ background: `url(${item.url}) no-repeat center / cover` }}
          />
        </button>
      )}
      {modalopen ? (
        <ModalPortal>
          <ModalReviewDetail
            deviceCheck={deviceCheck}
            handleCloseModal={handleCloseModal}
            images={images}
          />
        </ModalPortal>
      ) : null}
    </div>
  )
}
